export default function shortenLikesCount(likes) {
  if (likes >= 1000000) {
      return Math.floor(likes / 100000) / 10 + 'M';
  } else if (likes >= 1000) {
      return Math.floor(likes / 100) / 10 + 'K';
  } else {
      return likes.toString();
  }
}
